"use client";
import { Close } from "@/components/newIcons/Close";
import clsx from "clsx";
import { useState } from "react";
import { useInView } from "react-intersection-observer";
import { PrimaryButton, SecondaryButton } from "ui/components";
import type { Version } from "../../getVersion";
import { InnerMap } from "./InnerMap";

type Props = {
  data: NonNullable<Version["mapData"]>;
};
export const MainMap = ({ data }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { ref, inView } = useInView({
    rootMargin: "300px",
    triggerOnce: true,
  });

  return (
    <>
      <SecondaryButton className="mt-5 lg:hidden" onClick={() => setIsOpen(true)}>
        Ouvrir la carte
      </SecondaryButton>
      <div
        className={clsx("lg:border border-[#E5E5E5] lg:rounded-[5px] lg:mt-14 lg:p-5", {
          "max-lg:fixed max-lg:inset-0 z-20": isOpen,
        })}
      >
        <div className="lg:aspect-video max-lg:w-full max-lg:h-full z-20" ref={ref}>
          {inView && <InnerMap data={data} isOpen={isOpen} />}
          {isOpen && (
            <PrimaryButton size="icon" className="absolute top-5 right-5 lg:hidden" onClick={() => setIsOpen(false)}>
              <Close className="w-4 h-4" />
            </PrimaryButton>
          )}
        </div>
      </div>
    </>
  );
};
